export const SET_PATIENTS = 'SET_PATIENTS'
export const SET_PATIENTS_FILTERED = 'SET_PATIENTS_FILTERED'
export const SET_NURSES = 'SET_NURSES'
export const SET_SEARCHED_ITEM = 'SET_SEARCHED_ITEM'